"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotspotsFloatElement = exports.HotspotsComponent = void 0;
var hotspots_1 = require("./hotspots");
Object.defineProperty(exports, "HotspotsComponent", { enumerable: true, get: function () { return hotspots_1.HotspotsComponent; } });
var hotspots_float_element_1 = require("./hotspots-float-element");
Object.defineProperty(exports, "HotspotsFloatElement", { enumerable: true, get: function () { return hotspots_float_element_1.HotspotsFloatElement; } });
